var __default__ = {tooltip:'m_1b3c8819',arrow:'m_f898399f'};
export default __default__;